import { useEffect } from "react";
import { useToast } from "./ToastProvider";

// Bridges a state-held error message into the toast queue: the moment a
// message appears it becomes an Error toast and the holder is told to
// clear its state — display and dismissal belong to the queue from
// there. (The ErrorToast overlay this replaces made each page render its
// own floating error, TTTL-179 loose end.)
export function useErrorToast(
  message: string | null | undefined,
  onConsumed: () => void,
) {
  const { toast } = useToast();
  useEffect(() => {
    if (!message) return;
    toast({ state: "Error", message });
    onConsumed();
  }, [message, toast, onConsumed]);
}
